export const MICRO_APP_ORIGIN = window.__MICRO_APP_ENVIRONMENT__ && window.__MICRO_APP_PUBLIC_PATH__ ? new URL(window.__MICRO_APP_PUBLIC_PATH__).origin || '' : '';
export const getAbsoluteUrl = url => {
  if (!/^(http:|https:|\/\/)/.test(url) && MICRO_APP_ORIGIN) {
    return `${MICRO_APP_ORIGIN}${url}`;
  }
  return url;
};
//# sourceMappingURL=microApp.js.map
